<template>
  <div class="custom-card-box">
    <a-form
      class="custom-compact-form"
      :form="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 15 }"
      @submit="handleSubmit"
    >
      <a-form-item label="讣告宣传地址">
        <div>此处参数用于讣告宣传地址。讣告图片地址分为吊唁地址、公司地址，两种使用场景：</div>
        <div>场景1：如果发送讣告时没有输入自定义地址，则讣告单的吊唁地址取此处维护的讣告宣传地址，公司地址不显示。</div>
        <div>场景2：如果发送讣告时输入自定义地址，则吊唁地址取输入内容，同时显示公司地址，公司地址取此处维护的讣告宣传地址。</div>
        <div>注意，若地址多个，可通过点击“enter”键进行换行显示，为保证显示效果，建议行数不超过4行，一行字数不超过30。</div>
        <a-textarea
          auto-size
          v-decorator="['obituary_promotional_address', {
            rules: [
              { required: true, message: '请输入讣告宣传地址' },
              { max: 100, message: '最多100个字符' },
            ]
          }]"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="结算单底栏信息">
        <span>此处参数用于打印出的结算单底栏信息，若需要多行显示，可通过点击"enter"键进行换行显示，为保证显示效果，建议行数不超过4行，一行字数不超过30。</span>
        <a-textarea
          auto-size
          v-decorator="['settlement_footer', {
            rules: [
              { required: true, message: '请输入结算单底栏信息' },
              { max: 200, message: '最多200个字符' },
            ]
          }]"
          autocomplete="off"
        />
      </a-form-item>
    </a-form>

    <a-button style="color: white;background-color: #2d63ab;margin-left: 290px" @click="handleSubmit">保存</a-button>

  </div>
</template>

<script>
import { findOtherParameterConfiguration, updateOtherParameterConfiguration } from '@/api/other_parameter_configuration'

export default {
  name: 'ConfirmationFormTemplate',
  components: {
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'other_parameter_configuration' }),
      data: {},
      loading: true
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      findOtherParameterConfiguration().then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.initFormData()
        }
        this.loading = false
      })
    },

    initFormData() {
      this.form.setFieldsValue({
        obituary_promotional_address: this.data.obituary_promotional_address,
        settlement_footer: this.data.settlement_footer
      })
    },

    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          updateOtherParameterConfiguration(values)
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-form-item-control {
  line-height: 25px;
}

</style>
